import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTopHeader, uplodateLoading } from '../../../redux/features/common/commonSlice'
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast, showToast } from '../../constants/toaster';
import { Box, Pagination, Button, Modal } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import InsufficientPermission from '../../custom/InSufficientPermission';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import TextField from '@mui/material/TextField';


import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
// import Button from '@mui/material/Button';
import { v4 as uuidv4 } from 'uuid';
import { formatIndianNumber } from '../../lib/formatIndianNumber';

const label = { inputProps: { 'aria-label': 'Size switch demo' } };

export const UPIWithdrawManager = () => {
  const dispatch = useDispatch();
  const userData = useSelector(state => state?.userData);
  const [datalist, setDatalist] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSizeInput, setPageSizeInput] = useState(25);
  const [callAPi, setCallAPi] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [status, setStatus] = useState("PENDING");


  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });
  const [showQR, setShowQR] = useState(false);
  const [selectedWithdraw, setSelectedWithdraw] = useState(null);
  const [searchText, setSearchText] = useState("");
  const userPermisiions = useSelector(state => state?.permission);
  let currentModulePermission;
  let viewPermission = true;
  if (userPermisiions?.modules?.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => element.moduleId === '31')?.permissions;
    if (currentModulePermission) {
      viewPermission = currentModulePermission.find((element) => element.name === 'VIEW')?.isEnable;
    }
  }

  const [pageInput, setPageInput] = useState(page);
  useEffect(() => {
    setPageInput(page); // keep input in sync with actual page
  }, [page]);



  useEffect(() => {
    dispatch(updateTopHeader("UPI Withdraw Manager"));
  }, []);
  useEffect(() => {
    getWithdrawHistory();
    // eslint-disable-next-line
  }, [page, callAPi]);

  // Add debug log to check datalist before render
  useEffect(() => {

  }, [datalist, pagerecord]);


  const handlePageSizeInputChange = (e) => {
    setPageSizeInput(e.target.value);
  };

  const handlePageSizeSubmit = () => {
    let val = Number(pageSizeInput);

    // Validate the input
    if (val < 1 || isNaN(val)) {
      val = 25; // Revert to default
    } else if (val > 500) {
      val = 500; // Enforce max
    }

    // Update the input field to show the validated number
    setPageSizeInput(val);

    // Only call the API if the page size is actually changing
    if (val !== pagerecord.pageSize) {
      // This is where we finally update your REAL pagerecord state
      setPagerecord(prev => ({ ...prev, pageNumber: 1, pageSize: val }));
      setPage(1);
      setPageInput(1); // Reset the "go to page" input as well
      setCallAPi(uuidv4()); // Call the API
    }
  };

  const getWithdrawHistory = async (searchValue = searchText) => {
    try {
      dispatch(uplodateLoading(true));
      let postJson = {
        sort: 'createdAt',
        order: false,
        page: page - 1, // API expects 0-based page
        limit: pagerecord.pageSize,
        txnId: '',
        toUserId: searchValue,
        transactionType: 'ALL',
        startDate: startDate || null,
        endDate: endDate || null,
        status: status || "PENDING"

      };
      let res = await ApiCaller.post(postJson, urls.cashWithdrawHistory, userData?.access_token);
      const response = await res.response.json();
      // Debug: log the actual API response
      console.log('Withdraw API response:', response);
      // Correct extraction for nested API response
      const apiData = response.data && response.data.data ? response.data.data : response.data;
      if (
        response.status === 'OK' ||
        response.status === 200 ||
        response.status === '200' ||
        response.code === '200'
      ) {
        dispatch(uplodateLoading(false));
        setDatalist(Array.isArray(apiData.items) ? apiData.items : []);
        setPagerecord({
          totalItems: apiData.totalItems || (apiData.items ? apiData.items.length : 0),
          totalPages: apiData.totalPages || 1,
          pageNumber: (typeof apiData.pageNumber === 'number' ? apiData.pageNumber + 1 : page),
          pageSize: apiData.pageSize || pagerecord.pageSize
        });
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      showDangerToast(error.message);
    }
  };

  const handlePay = (item) => {
    setSelectedWithdraw(item);
    setShowQR(true);
  };

  const handleMarkPaid = async () => {
    try {
      dispatch(uplodateLoading(true));
      let postJson = {
        id: selectedWithdraw.id,
        statusType: 'PAID'
      };
      let res = await ApiCaller.post(postJson, urls.updateWithdrawStatus, userData?.access_token);
      const response = await res.response.json();
      // Accept both status/code 200 and httpStatus OK
      if (
        response.status === 'OK' ||
        response.status === 200 ||
        response.status === '200' ||
        response.code === '200' ||
        response.httpStatus === 'OK'
      ) {
        dispatch(uplodateLoading(false));
        showToast('Marked as PAID');
        setShowQR(false);
        getWithdrawHistory();
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      showDangerToast(error.message);
    }
  };

  const handleReject = async (item) => {
    try {
      dispatch(uplodateLoading(true));
      // Use the passed item or fallback to selectedWithdraw
      const withdraw = item || selectedWithdraw;
      if (!withdraw || !withdraw.id) {
        dispatch(uplodateLoading(false));
        showDangerToast('Invalid withdrawal request.');
        return;
      }
      let postJson = {
        id: withdraw.id,
        statusType: 'REJECT'
      };
      let res = await ApiCaller.post(postJson, urls.updateWithdrawStatus, userData?.access_token);
      const response = await res.response.json();
      if (
        response.status === 'OK' ||
        response.status === 200 ||
        response.status === '200' ||
        response.code === '200' ||
        response.httpStatus === 'OK'
      ) {
        dispatch(uplodateLoading(false));
        showToast('Request Rejected');
        setShowQR(false);
        getWithdrawHistory();
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      showDangerToast(error.message);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const exportToExcel = () => {
    if (!datalist || datalist.length === 0) {
      showDangerToast("No data to export");
      return;
    }

    // 1. Format the data to match your table structure
    // This creates a new array with user-friendly headers
    const formattedData = datalist.map(data => ({
      "User ID": data?.id ? data.id.toString().padStart(8, '0') : '',
      "User Name": data?.userName,
      "Amount": data?.currency + ' ' + data?.amount,
      "Actual Amount": data?.currency + ' ' + data?.actualAmount,
      "Base Amount": data?.currency + ' ' + data?.baseAmount,
      "Gst Amount": data?.currency + ' ' + data?.gstAmount,
      "Tax Amount": data?.currency + ' ' + data?.taxAmount,
      "Amount After tax": data?.currency + ' ' + data?.amountAfterTax,
      "UpiId": data?.upiId ?? '--',
      "Transaction Status": data?.txnStatus,
      "Gst Percentage": data?.gstPercentage,
      "Tax Percentage": data?.taxPercentage,
      "Created Date": data?.createdDate,

    }));

    // 2. Create worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "upi-withdraw");

    // 3. Generate the binary string
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

    // 4. Helper function to convert string to ArrayBuffer
    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      return buf;
    };

    // 5. Create Blob and trigger download
    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
    saveAs(blob, 'upi-withdraw.xlsx'); // This is the file name
  };
  const handleGenerateBankXls = async () => {
    try {
      dispatch(uplodateLoading(true));

      const postJson = {
        from: startDate || null,
        to: endDate || null,
        status: status || "PENDING"
      };

      let res = await ApiCaller.post(postJson, urls.generateBankPayout, userData?.access_token);
      const response = await res.response.json();

      dispatch(uplodateLoading(false));

      if (response.status === 200 || response.status === "200" || response.httpStatus === "OK") {
        showToast("Bank XLS generated & uploaded successfully!");
        showToast("File: " + response.file);
        setCallAPi(uuidv4());
      } else {
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      showDangerToast("Error generating payout XLS");
    }
  };


  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        {viewPermission ? (
          <div className='container-fluid mt--7'>
            <div className='row'>
              <div className='col text-left'>
                <div className='card shadow mb-4'>

                  <div className='card-header border-0 '>
                    <h3 className='mb-0'>UPI Withdraw Manager</h3>

                    <div className='row align-items-center text-left '>
                      <div className='col-md-3'>
                        <InputGroup className='mb-2' style={{ borderRadius: '10px' }}>
                          <Form.Control
                            placeholder='Search by User Name'
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') { setPage(1); getWithdrawHistory(e.target.value); } }}
                          />
                        </InputGroup>
                      </div>
                      <div className="col-md-3 mb-2">
                        <TextField
                          type="date"
                          label="Start Date"
                          InputLabelProps={{ shrink: true }}
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          fullWidth
                        />
                      </div>

                      <div className="col-md-3 mb-2">
                        <TextField
                          type="date"
                          label="End Date"
                          InputLabelProps={{ shrink: true }}
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          fullWidth
                        />
                      </div>

                      <div className="col-md-2 mb-2">
                        <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                          <option value="ALL">All</option>
                          <option value="PENDING">Pending</option>
                          <option value="PROCESSING">Processing</option>
                          <option value="PAID">Paid</option>
                          <option value="REJECT">Rejected</option>
                        </Form.Select>
                      </div>

                      <div className="col-md-2 mb-2">
                        <Button
                          variant="contained"
                          onClick={() => { setPage(1); getWithdrawHistory(); }}
                        >
                          Filter
                        </Button>
                      </div>

                      <div className='col-md-3 mb-2 d-flex justify-content-between align-items-center'>
                        <Button
                          variant='contained'
                          className='custom-filter-btn'
                          onClick={() => { setPage(1); getWithdrawHistory(searchText); }}
                        >
                          Search
                        </Button>

                        {/* <Button
                          variant="contained"
                          color="success"
                          onClick={handleGenerateBankXls}
                          sx={{ marginLeft: "15px" }}
                        >
                          Generate Bank XLS & Send
                        </Button> */}

                        <Button
                          variant='contained'
                          className='ml-2 custom-filter-btn'
                          onClick={() => { setSearchText(''); setPage(1); getWithdrawHistory(''); }}
                        >
                          Reset
                        </Button>


                      </div>

                    </div>

                  </div>
                  <div className='card-body'>
                    <div className='table-responsive'>
                      <table className='table align-items-center table-flush'>
                        <thead className='thead-light'>
                          <tr>
                            <th>#</th>
                            <th>User Name</th>
                            <th>GST %</th>
                            <th>Tax %</th>
                            <th>Actual Amount</th>
                            <th>Base Amount</th>
                            <th>GST Amount</th>
                            <th>Tax Amount</th>
                            <th>Amount After Tax</th>
                            <th>Final Amount</th>
                            <th>Currency Code</th>
                            <th>UPI ID</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(datalist) && datalist.length > 0 ? datalist.map((item, idx) => (
                            <tr key={item.id}>
                              <td>{(pagerecord.pageNumber - 1) * pagerecord.pageSize + idx + 1}</td>
                              <td>{item.userName}</td>
                              <td>{item.gstPercentage !== undefined && item.gstPercentage !== null ? Number(item.gstPercentage).toFixed(2) : '-'}</td>
                              <td>{item.taxPercentage !== undefined && item.taxPercentage !== null ? Number(item.taxPercentage).toFixed(2) : '-'}</td>
                              <td>{item.actualAmount !== undefined && item.actualAmount !== null ? formatIndianNumber(item.actualAmount) : '-'}</td>
                              <td>{item.baseAmount !== undefined && item.baseAmount !== null ? formatIndianNumber(item.baseAmount) : '-'}</td>
                              <td>{item.gstAmount !== undefined && item.gstAmount !== null ? formatIndianNumber(item.gstAmount) : '-'}</td>
                              <td>{item.taxAmount !== undefined && item.taxAmount !== null ? formatIndianNumber(item.taxAmount) : '-'}</td>
                              <td>{item.amountAfterTax !== undefined && item.amountAfterTax !== null ? formatIndianNumber(item.amountAfterTax) : '-'}</td>
                              <td>{item.amount !== undefined && item.amount !== null
                                ? (() => {
                                  const num = Number(item.amount);
                                  const decimal = num - Math.floor(num);
                                  if (decimal <= 0.5) {
                                    return Math.floor(num);
                                  } else {
                                    return Math.ceil(num);
                                  }
                                })()
                                : '-'}</td>
                              <td>{item.currencyCode || '-'}</td>
                              <td>{item.upiId}</td>
                              <td>{item.createdDate}</td>
                              <td>{item.txnStatus}</td>
                              <td>
                                {item.txnStatus !== 'SUCCESS' && (
                                  <>
                                    <Button
                                      variant='contained'
                                      color='primary'
                                      size='small'
                                      onClick={() => handlePay(item)}
                                      disabled={item.txnStatus === 'PAID' || item.txnStatus === 'REJECT'}
                                    >
                                      Pay
                                    </Button>
                                    <Button
                                      variant='outlined'
                                      color='error'
                                      size='small'
                                      onClick={() => handleReject(item)}
                                      style={{ marginLeft: 8 }}
                                      disabled={item.txnStatus === 'PAID' || item.txnStatus === 'REJECT'}
                                    >
                                      Reject
                                    </Button>
                                  </>
                                )}
                              </td>
                            </tr>
                          )) : (
                            <tr><td colSpan={15} className='text-center'>No Data Found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <Box display='flex' justifyContent='space-between' alignItems='center' mt={3}>
                      <Button
                        variant="contained"
                        onClick={exportToExcel}
                        disabled={!datalist || datalist.length === 0}
                        sx={{ mr: 2, mb: { xs: 1, sm: 0 } }}
                      >
                        Export to Excel
                      </Button>
                      <TextField
                        label="Page Size"
                        type="number"
                        inputProps={{ min: 1, max: 500 }}
                        value={pageSizeInput}
                        onChange={handlePageSizeInputChange}
                        onBlur={handlePageSizeSubmit}
                        onKeyDown={(e) => e.key === "Enter" && handlePageSizeSubmit()}
                        size="normal"
                        sx={{ mr: 2, width: 140 }}
                      />
                      <span>Total record: {pagerecord?.totalItems}</span>
                      <Pagination
                        className='custom-pagination-class'
                        count={pagerecord?.totalPages}
                        page={page}
                        onChange={handleChange}
                        color='secondary'
                      />
                    </Box>
                  </div>
                </div>
                <Modal open={showQR} onClose={() => setShowQR(false)}>
                  <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', p: 4, borderRadius: 2, boxShadow: 24 }}>
                    <h4>Scan & Pay with PhonePe/UPI</h4>
                    {selectedWithdraw && (
                      <div style={{ textAlign: 'center' }}>
                        <QRCodeCanvas value={`upi://pay?pa=${selectedWithdraw.upiId}&pn=${selectedWithdraw.userName}&am=${(() => {
                          const num = Number(selectedWithdraw.amount);
                          const decimal = num - Math.floor(num);
                          if (decimal <= 0.5) {
                            return Math.floor(num);
                          } else {
                            return Math.ceil(num);
                          }
                        })()}&cu=INR`} size={200} />
                        <div className='mt-3'>
                          <Button variant='contained' color='success' onClick={handleMarkPaid}>Mark as Paid</Button>
                          <Button variant='outlined' color='error' onClick={() => handleReject(selectedWithdraw)} style={{ marginLeft: 8 }}>Reject</Button>
                          <Button variant='outlined' color='secondary' onClick={() => setShowQR(false)} style={{ marginLeft: 8 }}>Close</Button>
                        </div>
                      </div>
                    )}
                  </Box>
                </Modal>
              </div>
            </div>
          </div>
        ) : (
          <InsufficientPermission />
        )}
      </div>
    </>
  );
};

export default UPIWithdrawManager;
